// WP-1.17 (NT-B): the infra alert banner strip — shows active backup-failed / bridge-down
// banners at the top of the shell, each dismissible. Renders nothing when all clear.
import { X } from 'lucide-react';
import { useAlerts, useDismissAlert } from '../lib/alerts';

export function AlertBanner(): React.JSX.Element | null {
  const { data: alerts } = useAlerts();
  const dismiss = useDismissAlert();
  if (alerts === undefined || alerts.length === 0) return null;

  return (
    <div>
      {alerts.map((alert) => (
        <div
          key={alert.id}
          role="alert"
          className={`flex items-center justify-between gap-3 px-4 py-2 text-sm ${
            alert.severity === 'error' ? 'bg-danger/10 text-danger' : 'bg-warning/10 text-warning'
          }`}
        >
          <span>{alert.message}</span>
          <button
            type="button"
            aria-label="Dismiss alert"
            className="shrink-0 rounded p-1 hover:bg-black/5"
            disabled={dismiss.isPending}
            onClick={() => {
              dismiss.mutate(alert.id);
            }}
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
}
